<template>
  <div class="form-box">
    <el-form ref="form" :model="form" style="width: 100%; padding: 60px">
      <el-form-item label="用户名">
        <el-input v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="密 码">
        <el-input v-model="form.password" password ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="loading"
          type="primary"
          @click.native.prevent="handleLogin"
          style="width:100%"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import idaas from "@/apis/idaas";
export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      loading: false,
      state: null
    };
  },
  cetated(){
    this.state = this.$route.query.state
  },
  methods:{
    async handleLogin(){
      let res = await idaas.auth(this.form)
      await idaas.binduser(res.data.userId,state)
      this.$message.success('绑定成功')
    },
  }
};
</script>

<style scoped>
.form-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
